import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import FRXLogo from "../../assets/fr-x.png";
import { useDispatch } from "react-redux";
import { CredentialsType } from "@/common/types";
import { login } from "@/redux/actions/authAction";
import { useToast } from "@/hooks/use-toast";

const Login = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [state, setState] = useState<CredentialsType>({
    username: "",
    password: "",
  });

  const { toast } = useToast();

  const handleChange = (key: string, value: string) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleLogin = () => {
    dispatch(
      login(
        state,
        () => navigate("/"),
        (message: string) => {
          toast({
            variant: "destructive",
            description: message,
          });
        }
      )
    );
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <div className="flex flex-col items-center justify-center w-full md:w-2/3 h-[50vh] md:h-full bg-gray-100">
        <img src={FRXLogo} alt="Company Logo" className="mb-4 w-40" />
        <h1 className="text-2xl font-bold">Welcome to Our Company</h1>
        <p className="mt-2 text-gray-600">
          "Your gateway to a better experience."
        </p>
      </div>

      <Separator orientation="vertical" className="hidden md:block" />

      <div className="flex flex-col justify-center w-full md:w-1/3 h-[50vh] md:h-full p-8 bg-white">
        <h2 className="text-xl font-semibold mb-4">
          "Welcome Back, Let's Get Started!"
        </h2>
        <div className="mb-4">
          <Input
            id="email"
            aria-label="Email"
            type="email"
            placeholder="Email"
            className="border rounded p-2 w-full"
            required
            onChange={(e) => handleChange("username", e.target.value)}
            autoComplete="email"
          />
        </div>
        <div className="mb-4">
          <Input
            type="password"
            placeholder="Password"
            className="border rounded p-2 w-full"
            required
            onChange={(e) => handleChange("password", e.target.value)}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                handleLogin();
              }
            }}
          />
        </div>
        <Button
          className="w-full"
          onClick={handleLogin}
          disabled={!state.username || !state.password}
        >
          Login
        </Button>
      </div>
    </div>
  );
};

export default Login;
